import LegalPage from "../../components/LegalPage";

export default function Contact() {
  return (
    <LegalPage title="Contact" kicker="Contact" hideDraftNotice>
      <p>
        Pour toute question, signalement ou demande, vous pouvez nous
        contacter par email :
      </p>
      <p>
        <a
          href="mailto:contact@otra-gaming.fr"
          className="text-cyan-300 hover:text-cyan-200"
          data-testid="contact-email-link"
        >
          contact@otra-gaming.fr
        </a>
      </p>
      <h2>Support joueur</h2>
      <p>
        Pour un problème avec un code, un paiement ou une session de jeu,
        merci d&apos;indiquer dans votre email :
      </p>
      <ul>
        <li>l&apos;adresse email de votre compte ;</li>
        <li>le code concerné (s&apos;il y en a un) ;</li>
        <li>le nom du défi ;</li>
        <li>un descriptif clair du problème rencontré.</li>
      </ul>
      <p>
        Nous nous engageons à répondre dans un délai raisonnable, en
        général sous 72 h ouvrées.
      </p>
    </LegalPage>
  );
}
